
import type { PropType } from 'vue'
import type { FeatureIdEnum } from '../../../enums/feature-id.enum'
import { defineComponent } from 'vue'
import { useToolingReportStats } from '../../../composables/use-tooling-report-stats'
import { EpbText } from '../../shared'

export default defineComponent({
  name: 'ToolReportingStats',
  components: {
    EpbText,
  },
  props: {
    tool: {
      type: String as PropType<FeatureIdEnum>,
      default: () => '',
    },
  },
  setup(props) {
    const baseClass = 'tool-reporting-stats'
    const { stats } = useToolingReportStats(props.tool)
    return {
      baseClass,
      stats,
    }
  },
})
